export default {
	"login": {
		"id": 6,
		"name": "登录部分",
		"isDrop": 1,
		"children": {
			"loginTitle": {
				"id": 7,
				"name": "欢迎登录",
				"remarks": "登录界面输入框上方标题"
			},
			"loginPasswordPlaceholder": {
				"id": 9,
				"name": "请输入密码",
				"remarks": "登录界面密码输入框内的提示信息"
			},
			"loginUsernamePlaceholder": {
				"id": 8,
				"name": "请输入账号",
				"remarks": "登录界面用户名输入框内的提示信息"
			}
		}
	},
	"floorText": {
		"id": 2,
		"name": "网站页脚部分",
		"isDrop": 1,
		"children": {
			"first": {
				"id": 3,
				"name": "哈尔滨商业大学",
				"remarks": "网页页脚第一部分文字内容"
			},
			"third": {
				"id": 5,
				"name": "",
				"remarks": "网页页脚第三部分文字内容"
			},
			"second": {
				"id": 4,
				"name": "咨询QQ群：12345678丨  联系邮箱：example@email.com",
				"remarks": "网页页脚第二部分文字内容"
			}
		}
	},
	"systemIco": {
		"id": 2.1,
		"name": "http://122.51.76.10:8807/files/uploads/20250407/2025040714060112780.png",
		"type": "img",
		"wrap": true,
		"remarks": "网站logo",
		"fieldName": "systemIco"
	},
	"systemTitle": {
		"id": 1,
		"name": "哈尔滨商业大学校舍维修管理系统",
		"remarks": "网站标题"
	},
}